import { AssumeRoleCommand, STSClient } from "@aws-sdk/client-sts"
import { config } from "@nova/configuration/node"
import { SupportedRegions } from "@nova/constants"
import { getIngestBucket } from "./buckets"

const stsClient = new STSClient({})

const SESSION_DURATION_SECONDS = 60 * 60

export type IngestCredentials = {
    accessKeyId: string
    secretAccessKey: string
    sessionToken: string
    expiration: string
}

export const getIngestCredentials = async ({
    userId,
}: {
    userId: string
}): Promise<IngestCredentials> => {
    const result = await stsClient.send(
        new AssumeRoleCommand({
            RoleArn: config.get("novaIngestUploadRoleArn"),
            RoleSessionName: `ingest-${userId.slice(0, 32)}`,
            DurationSeconds: SESSION_DURATION_SECONDS,
            Policy: JSON.stringify({
                Version: "2012-10-17",
                Statement: [
                    {
                        Effect: "Allow",
                        Action: [
                            "s3:PutObject",
                            "s3:CreateMultipartUpload",
                            "s3:UploadPart",
                            "s3:CompleteMultipartUpload",
                            "s3:AbortMultipartUpload",
                            "s3:ListMultipartUploadParts",
                            "s3:PutObjectTagging",
                        ],
                        Resource: Object.values(SupportedRegions).map(
                            (region) => `arn:aws:s3:::${getIngestBucket(region)}/user/${userId}/*`
                        ),
                    },
                ],
            }),
        })
    )

    const creds = result.Credentials
    if (!creds?.AccessKeyId || !creds.SecretAccessKey || !creds.SessionToken || !creds.Expiration) {
        throw new Error("Failed to obtain ingest credentials")
    }

    return {
        accessKeyId: creds.AccessKeyId,
        secretAccessKey: creds.SecretAccessKey,
        sessionToken: creds.SessionToken,
        expiration: creds.Expiration.toISOString(),
    }
}
